import {
    ROOT_URL
} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {
    fetchedMenus,
    fetchedMenuItems,
    fetchedMenuClasses
} from './actions';
import {getFlatDataFromTree} from 'react-sortable-tree';

export function fetchMenus() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/menus`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedMenus(response.data)))
    };
}

export function fetchMenuItems(id) {

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/menus/${id}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedMenuItems(response.data)))
    }
}

export function createMenuTranslation(menuId, formProps) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/menus/${menuId}`,
            method: 'POST',
            data: formProps
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchMenus()))
            .then(() => toastr.success('Success!', 'A new menu translation has been created. Please go to the Edit page to translate and arrange menu items!'))
    }
}

export function fetchMenuClasses() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/menu-classes`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedMenuClasses(response.data)))
    };
}

export function updateTreeData(menuId, menuItemsTreeData) {

    const flatData = getFlatDataFromTree({
            treeData: menuItemsTreeData,
            getNodeKey: ({node }) => node.id,
            ignoreCollapsed: false,
        }).map(({node, path, treeIndex }) => {
        return ({
            id: node.id,
            name: node.name,
            parent: path.length > 1 ? path[path.length - 2] : null,
            new: node.new,
            is_visible: node.is_visible,
            deleted: node.deleted,
            sort_order: treeIndex,
            clickable: node.clickable,
            page_id: node.page_id,
            css_class: node.css_class,
            href: node.href,
            expanded: !!node.expanded,
            type: node.type
        });
    });


    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/menus/${menuId}`,
            method: 'PUT',
            data: flatData
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchMenuItems(menuId)))
            .then(() => toastr.success('Success!', 'The menu tree has been updated with the changes you have made!'))
    }
}



// WEBPACK FOOTER //
// ./src/containers/menus/thunks.js